import React, {
    useEffect,
    useState,
    FC
} from 'react'

import CircularProgress from '@pixel/core/CircularProgress'
import ContentModal from '@pixel/core/ContentModal'
import {
    Typography,
} from "@pixel/core"
import LayoutRootSection from "@pixel/internal/LayoutRootSection";

import PreviewCandidate from './PreviewCandidate'

import useApplicationList, { Application } from './useApplicationList'
import useApplicationDetails from './useApplicationDetails'
import { useMultipleLocalizedText } from '../../../contexts/Localization/localizationHooks'

export function generateViewCandidateURL({ candidateEId, jobEId }: { candidateEId: string, jobEId: string }): string {
    return `${window.jvbaseurl}Hiring/ViewCandidate.aspx?a=${candidateEId}&j=${jobEId}&v=14`
}

export function generateViewJobURL({ jobEId }: { jobEId: string }): string {
    return `${window.jvbaseurl}Hiring/ViewJob.aspx?j=${jobEId}&v=14`
}

interface PreviewCandidateModalProps {
    open: boolean
    onClose: () => void

    candidateApplication: any
}
export const PreviewCandidateModal: FC<PreviewCandidateModalProps> = ({
    open,
    onClose,

    candidateApplication,
}) => {
    const {
        COMMON_PREVIEW,
        HIRE_CANCEL,
        VIEW_DETAILS,
    } = useMultipleLocalizedText()

    const [activeApplicationId, setActiveApplicationId] = useState(null)

    useEffect(() => {
        if (candidateApplication) {
            setActiveApplicationId(candidateApplication.EId)
        }
    }, [candidateApplication])

    const {
        data: applicationsList,
        error: applicationsListError,
        isLoading: applicationsListLoading,
    } = useApplicationList({ candidateId: candidateApplication ? candidateApplication.EId : null })
    const {
        data: applicationDetails,
        error: applicationDetailsError,
        isLoading: applicationDetailsLoading
    } = useApplicationDetails({ applicationId: activeApplicationId })

    const handleResolve = () => {
        window.location.href = generateViewCandidateURL({ 
            candidateEId: candidateApplication.EId, 
            jobEId: candidateApplication.jobEId,
        })
    }
    
    if (!open) return null

    const renderPreviewContent = () => {
        if (applicationsListLoading || applicationDetailsLoading) {
            return (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress size={34} />
                </div>
            )
        }

        if (applicationsListError) {
            return (
                <Typography>Error: {applicationsListError}</Typography>
            )
        }

        if (applicationDetailsError) {
            return (
                <Typography>Error: {applicationDetailsError}</Typography>
            )
        }

        return (
            <PreviewCandidate 
                activeApplicationId={activeApplicationId}
                candidateApplication={candidateApplication}
                candidateApplicationsList={applicationsList}
                applicationDetails={applicationDetails}
                onActiveApplicationChange={applicationId => setActiveApplicationId(applicationId)}
            />
        )
    }

    return (
        <ContentModal
            title={COMMON_PREVIEW}
            open={open}
            onClose={onClose}
            showClose
            sizeVariant="md"
            labelCloseAria="Close"
            rejectActions={[{
                reason: "cancel",
                label: HIRE_CANCEL,
            },]}
            resolveActions={[{
                reason: "ok",
                label: VIEW_DETAILS,
            },]}
            onResolve={handleResolve}
        >
            <LayoutRootSection top transparent>
                { renderPreviewContent() }
            </LayoutRootSection>
        </ContentModal>
    )
}

export default PreviewCandidateModal
